<section class=t0>
    <section class="panel-zone">
        <ng-content select="[panel-zone]"></ng-content>
    </section>
</section>
